import React from "react";
import { Button, Modal, ModalBody } from "reactstrap";

interface ConfirmModalProps {
    isOpen: boolean;
    typeConfirm: string;
    title: string;
    content: string;
    onConfirm: () => void;
    onCancel: () => void;
    loading?: boolean;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
   isOpen,
   typeConfirm,
   title,
   content,
   onConfirm,
   onCancel,
   loading = false,
}) => {
    const confirmColor = typeConfirm === "danger" ? "danger" : "primary";

    return (
        <React.Fragment>
            <Modal
                size="sm"
                isOpen={isOpen}
                toggle={onCancel}
                centered
                contentClassName="shadow rounded-4 border-0"
            >
                <ModalBody className="p-4">
                    <p className="mb-4 fs-6 text-dark">{content || title}</p>
                    <div className="d-flex justify-content-end gap-2">
                        <Button color="secondary" className="px-4 fw-semibold" onClick={onCancel}>
                            Hủy
                        </Button>
                        <Button color={confirmColor} className="px-4 fw-semibold" onClick={onConfirm} disabled={loading}>
                            {loading ? "Đang gửi..." : "Xác nhận"}
                        </Button>
                    </div>
                </ModalBody>
            </Modal>
        </React.Fragment>
    );
};

export default ConfirmModal;
